module.exports = __webpack_public_path__ + "img/bonus_phone_yn.88e5c7c6.png";